module.exports = __webpack_public_path__ + "static/media/logo-tecnoshow.3596cfac.png";